import { useState } from 'react';

import { Box, Button, Menu, MenuItem } from '@mui/material';

import { IcArrowDown } from '@/assets/images';
import { stage } from '@/config';
import { IUser, Role } from '@/models';
import { isTargetRole } from '@/services';
import { useUserStore } from '@/store';

type DashboardActionsProps = {
  onCreateIncident: () => void;
  onCreateCarStop: () => void;
  onCreateCarStopAtMapCenter: () => void;
  onCreateCFS: () => void;
};

const DashboardActions = ({
  onCreateIncident,
  onCreateCarStop,
  onCreateCarStopAtMapCenter,
  onCreateCFS,
}: DashboardActionsProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openActionsMenu = Boolean(anchorEl);
  const { user, account } = useUserStore();
  const isNonProd = stage !== 'prod';

  const handleCloseActionsMenu = () => {
    setAnchorEl(null);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleAction = (action: () => void) => () => {
    handleCloseActionsMenu();
    action();
  };

  const isCarStopEnabled =
    account?.settings?.features?.isEnabledCarStopCreation;
  const isCFSEnabled = account?.settings?.features?.isEnabledCFSCreation;
  const isIncidentEnabled =
    account?.settings?.features?.isEnabledIncidentReportCreation;

  const canCreateIncident =
    isIncidentEnabled &&
    isTargetRole(user as IUser, Role.RMS_CASES_FULL_ACCESS);

  const hasEnabledFeatures =
    isCarStopEnabled || isCFSEnabled || canCreateIncident;

  if (!hasEnabledFeatures) {
    return null;
  }

  return (
    <Box paddingLeft={2}>
      <Box>
        <Button
          variant="contained"
          color="error"
          onClick={handleClick}
          endIcon={<IcArrowDown />}
        >
          New
        </Button>
      </Box>
      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        open={openActionsMenu}
        onClose={handleCloseActionsMenu}
      >
        {isCarStopEnabled && !isNonProd && (
          <MenuItem onClick={handleAction(onCreateCarStop)}>Car Stop</MenuItem>
        )}
        {isCarStopEnabled && isNonProd && (
          <MenuItem onClick={handleAction(onCreateCarStopAtMapCenter)}>
            Car Stop (US Test Address)
          </MenuItem>
        )}
        {isCarStopEnabled && isNonProd && (
          <MenuItem onClick={handleAction(onCreateCarStop)}>
            Car Stop (Current Location)
          </MenuItem>
        )}
        {isCFSEnabled && (
          <MenuItem onClick={handleAction(onCreateCFS)}>CFS</MenuItem>
        )}
        {canCreateIncident && (
          <MenuItem onClick={handleAction(onCreateIncident)}>Incident</MenuItem>
        )}
      </Menu>
    </Box>
  );
};

export default DashboardActions;
